const auth = {
  namespaced: true,
  state: () => ({

  }),
  mutations: {
  },
  actions: {
  },
  getters: {
  }
}

export default auth